import { gql } from '@apollo/client';

export type Diagnosis = {
  primary: string;
  second: string;
  physiciansNote: string;
  patientMedications: string;
};

const DiagnosisFragment = gql`
  fragment DiagnosisFragment on DiagnosisInfo {
    primary
    second
    physiciansNote
    patientMedications
  }
`;

export default DiagnosisFragment;
